<template>
    <div>
        <router-link
            :to="`/jala_harvests/${item.jala_harvest_id}`"
        >{{ harvest.cycle.pond.farm.name }} - {{ harvest.cycle.pond.name }}</router-link>
        <!-- {{ item }} -->
    </div>
</template>

<script>
export default {
    props: ['item'],
    data(){
        return {
            harvest:[]
        }
    },
    mounted() {
        this.fetchModel();
    },
    methods: {
        fetchModel() {
            this.loading = true;
            return this.$axios.get(`/jala/harvests/${this.item.jala_harvest_id}`, {
                params: { with: 'cycle.pond.farm' }
            }).then((response) => {
                const { data: { data } } = response;
                this.model = data;
                this.harvest = data
                return response;
            }).catch((error) => this.failedAlert(error))
                .finally(() => this.loading = false)
        }
    }
}
</script>